import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IDateInput } from '../../models';
import { FieldBaseComponent } from '../base-component';
import { FormlyModule } from '@ngx-formly/core';
import { FormsModule } from '@angular/forms';

const enum KeyCodes {
  Tab = 9,
  Shift = 16,
}

@Component({
  selector: 'app-lib-ff-date-input',
  styleUrls: ['./date-input.component.scss'],
  templateUrl: './date-input.component.html',
  imports: [FormlyModule, FormsModule],
})
export class FormlyDateInputComponent extends FieldBaseComponent implements OnInit {
  @ViewChild('wrapperDiv', { static: true }) public wrapperDiv: ElementRef<HTMLElement>;
  public dateModel: IDateInput = {} as IDateInput;

  public constructor() {
    super();
  }

  public ngOnInit() {
    this.initialiseModel();
    this.form.valueChanges.subscribe(() => {
      this.initialiseModel();
    });
  }

  public isValid() {
    return this.formControl.touched && this.formControl.valid;
  }

  public isInvalid() {
    return this.formControl.touched && !this.formControl.valid;
  }

  public updateModel(value: number, key: keyof IDateInput) {
    this.dateModel[key] = value;
    this.patchValue();
  }

  public onBlur(fieldId: string) {
    if (fieldId === 'year') {
      this.formControl.markAsTouched();
      this.formControl.markAsDirty();
      this.patchValue();
    } else {
      this.formControl.markAsUntouched();
      this.formControl.markAsPristine();
    }
  }

  public onKeyup(event, nextFieldId: string) {
    const { which, target, shiftKey } = event;
    const { value, maxLength } = target as HTMLInputElement;

    if ((nextFieldId && which === KeyCodes.Tab && shiftKey) || which === KeyCodes.Shift) {
      return;
    }

    if (nextFieldId && value.length >= maxLength) {
      const element: HTMLInputElement = this.wrapperDiv.nativeElement.querySelector(`#${nextFieldId}`);
      element.focus();
    }
    if (!nextFieldId && value.length >= maxLength) {
      this.formControl.markAsTouched();
      this.formControl.markAsDirty();
    }
  }

  public onKeydown(event, currentFieldId: keyof IDateInput) {
    const { which, target, shiftKey } = event;
    const { value, maxLength } = target as HTMLInputElement;

    if (which === KeyCodes.Tab && !shiftKey && value.toString().length > 0) {
      this.dateModel[currentFieldId] = value.padStart(maxLength, '0') as unknown as number;
    }
  }

  public patchValue() {
    this.formControl.setValue(this.dateModel);
    this.form.patchValue({ [this.field.key as string]: { ...this.dateModel } } as any);
  }

  private initialiseModel() {
    this.dateModel = this.model[this.field.key as string] ?? {};
  }
}
